import {
  requestDelete,
  requestGet,
  requestPostFile,
  requestPut,
  api,
  requestPost,
} from "../config/Api";

const name = "lawsuit";

export const uploadFile = (data) => {
  return requestPostFile(`${name}/upload`, data);
};

export const getLawyersLawsuit = (params) => {
  return requestGet(`${name}/get/lawyers`, { params });
};

export const getLawsuits = (params = {}) => {
  return requestGet(`${name}`, { params });
};

export const deleteLawsuit = (id) => requestDelete(`${name}/${id}`);

export const updateLawsuit = (id, data) => requestPut(`${name}/${id}`, data);

export const downloadFilePost = async (url, data = {}) => {
  return await api.post(url, data, {
    responseType: "blob",
  });
};

export const getLawsuitsFailure = (params) => {
  return requestGet("lawsuit/failures/get", { params });
};

export const createUploadLawsuit = (data) => {
  return requestPostFile("lawsuit/upload/online", data);
};

export const previewUploadLawsuitLawyers = (data) => {
  return requestPostFile("lawsuit/upload/online/preview-lawyers", data);
};

export const deleteUploadLawsuit = (data) => {
  return requestPostFile("lawsuit/upload/delete", data);
};

export const updateUploadLawsuit = (data) => {
  return requestPostFile("lawsuit/upload/update", data);
};

export const importLawsuitConcluded = (data) => {
  return requestPostFile('lawsuit/concluded', data);
};

export const previewLawsuitConcludedLawyers = (data) => {
  return requestPostFile('lawsuit/concluded/preview-lawyers', data);
};

export const associateLawsuitLegalFile = (data) => {
  return requestPostFile("lawsuit/associate/legal/file", data);
};

export const previewRevertSpreadsheet = (payload) =>
  requestPost("lawsuit/revert/spreadsheet/preview", payload);

export const confirmRevertSpreadsheet = (payload) =>
  requestPost("lawsuit/revert/spreadsheet/confirm", payload);

export const uploadHistoricalLawsuits = (data) => {
  return requestPostFile("lawsuit/upload/historical", data);
};

export const updateLawsuitJucAndLegalFile = (data) => {
  return requestPostFile("lawsuit/update/juc/legal/file", data);
};
